
<div style="margin-top: 100px;">

<div style="display: flex; justify-content: center; align-items: center;">
  <span class="toolbar-logo-container"> <img src="{{ getLogoUrl() }}" class="toolbar-logo" style="height: 100px;"/> </span>
</div>

<div style="display: flex; justify-content: center; align-items: center; font-weight: bold; margin-top: 50px;">
  SITE UNAVAILABLE FOR MAINTENANCE
</div>

<div class="display-text primary-dark-color-important" style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
 {{ maintenanceDate }}: The Tuition Options website is currently undergoing scheduled maintenance.
</div>

<div class="display-text primary-dark-color-important" style="display: flex; justify-content: center; align-items: center; margin-top: 25px;">
  Please try your request again later. We apologize for any inconvenience.
</div>

</div>
